import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import { api } from "@/api/client";

export default function GlobalSearch({ onClose }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/search?q=${encodeURIComponent(q)}`);
        setResults(data.results || []);
      } catch {}
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  const openResult = (r) => {
    if (r.type === "finance") nav("/finance");
    else if (r.type === "invoice") nav("/business");
    else if (r.type === "company" || r.type === "client") nav("/masters");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm flex items-start justify-center pt-24 p-4" onClick={onClose} data-testid="global-search-panel">
      <div className="w-full max-w-xl bg-white rounded-lg border border-neutral-200 shadow-2xl fade-in" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 px-4 py-3 border-b border-neutral-200">
          <MagnifyingGlass size={18} className="text-neutral-400" />
          <input
            data-testid="global-search-input"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search finance, invoices, companies, clients..."
            className="flex-1 outline-none text-sm"
          />
          <button onClick={onClose} className="p-1 rounded hover:bg-neutral-100"><X size={16} /></button>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {results.length === 0 && q && <div className="p-6 text-sm text-neutral-500 text-center">No results</div>}
          {results.map((r, i) => (
            <button key={i} data-testid={`search-result-${i}`} onClick={() => openResult(r)} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-neutral-50 text-left border-b border-neutral-100 last:border-0 transition-colors duration-200">
              <span className="dos-badge bg-neutral-100 text-neutral-600">{r.type}</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-neutral-900 truncate">{r.title}</div>
                {r.subtitle && <div className="text-xs text-neutral-500 truncate">{r.subtitle}</div>}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
